import { useState, useEffect } from 'react';

export default function TypewriterText({ 
  texts, 
  speed = 100, 
  pause = 2000, 
  className = '' 
}) {
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [currentText, setCurrentText] = useState('');
  const [isTyping, setIsTyping] = useState(true);

  useEffect(() => {
    let timeout;

    const typeText = () => {
      const fullText = texts[currentTextIndex];

      if (isTyping) {
        if (currentText.length < fullText.length) {
          setCurrentText(fullText.substring(0, currentText.length + 1));
          timeout = setTimeout(typeText, speed);
        } else {
          timeout = setTimeout(() => setIsTyping(false), pause);
        }
      } else {
        if (currentText.length > 0) {
          setCurrentText(fullText.substring(0, currentText.length - 1));
          timeout = setTimeout(typeText, speed / 2);
        } else {
          setCurrentTextIndex((prev) => (prev + 1) % texts.length);
          setIsTyping(true);
        }
      }
    };

    timeout = setTimeout(typeText, speed);

    return () => clearTimeout(timeout);
  }, [currentText, currentTextIndex, isTyping, texts, speed, pause]);

  return (
    <span className={className}>
      {currentText}
      <span className="blink-cursor"></span>
    </span>
  );
}
